import { ReviewSummary } from '../../shared/models/review-summary.model';


/**
 * Model for storing basic information about a flying club (such as the ID, and name). See Business class for
 * a more complete data model.
 */
export class FlyingclubSummary {
  /**
   * Unique identifier for this record in the database
   */
  id: string;

  /**
   * Business name
   */
  name: string;

  /**
   * Primary contact phone number of the business
   */
  phone1: string;

  /**
   * The type of flying club ("AOPA Network Club", "Club in Formation", "Other").
   */
  clubType: string;

  /**
   * Indicates if the club is taking new members
   */
  newMembers: boolean;

  /**
   * Current number of club members
   */
  clubMembers: number;

  /**
   * Number of aircraft in club
   */
  clubAircraft: number;

  /**
   * Summary object of reviews for this entity
   */
  reviewSummary: ReviewSummary;

  /**
   * Indicates if the club should be hidden to public
   */
  hideBusiness: boolean;

  /**
   * Indicates whether the business has been approved by AOPA
   */
  notApproved: boolean;

  /**
   * Parses business summary
   * @param data {any} Business summary data as returned by API
   * @return {BusinessSummary} Parsed business summary
   */
  static parse(data: any): FlyingclubSummary {
    return Object.assign(new FlyingclubSummary(), {
      id: data.businessId,
      name: data.name,
      phone1: data.phone1,
      clubType: data.clubType || null,
      newMembers: data.newMembers,
      clubMembers: data.clubMembers || 0,
      clubAircraft: data.clubAircraft || 0,
      reviewSummary: data.reviewSummary,
      hideBusiness: data.hideBusiness,
      notApproved: data.notApproved
    });
  }
}
